<!-- Calendar Header -->
<div class="hx-calendar__header">
  <button
    class="hx-calendar__nav-button hx-calendar__nav-button--previous"
    type="button"
    [attr.aria-label]="'Previous ' + currentView()"
    [title]="'Previous ' + currentView()"
    [disabled]="previousDisabled()"
    (click)="goPrevious()">
    <svg aria-hidden="true" fill="currentColor" focusable="false" height="16" viewBox="0 0 16 16" width="16">
      <path
        d="M10 12L6 8L10 4"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none" />
    </svg>
  </button>

  <button
    class="hx-calendar__period-button"
    type="button"
    [attr.aria-label]="'Switch to ' + (currentView() === 'month' ? 'year' : 'multi-year') + ' view'"
    [disabled]="currentView() === 'multi-year'"
    (click)="switchToBroaderView()">
    {{ periodLabel() }}
  </button>

  <button
    class="hx-calendar__nav-button hx-calendar__nav-button--next"
    type="button"
    [attr.aria-label]="'Next ' + currentView()"
    [title]="'Next ' + currentView()"
    [disabled]="nextDisabled()"
    (click)="goNext()">
    <svg aria-hidden="true" fill="currentColor" focusable="false" height="16" viewBox="0 0 16 16" width="16">
      <path
        d="M6 4L10 8L6 12"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none" />
    </svg>
  </button>
</div>

<!-- Calendar Views -->
<div class="hx-calendar__content">
  @switch (currentView()) {
    @case ('month') {
      <hx-month-view
        [activeDate]="activeDate()"
        [dateAdapter]="dateAdapter()"
        [dateFilter]="dateFilter()"
        [maxDate]="maxDate()"
        [minDate]="minDate()"
        [rangeEnd]="rangeEnd()"
        [rangeStart]="rangeStart()"
        [selected]="selected()"
        (activeDateChange)="onActiveDateChange($event)"
        (selectedChange)="onDateSelected($event)" />
    }
    @case ('year') {
      <hx-year-view
        [activeDate]="activeDate()"
        [dateAdapter]="dateAdapter()"
        [maxDate]="maxDate()"
        [minDate]="minDate()"
        [allowedYears]="allowedYears()"
        [selected]="selected()"
        (activeDateChange)="onActiveDateChange($event)"
        (selectedChange)="onDateSelected($event)" />
    }
    @case ('multi-year') {
      <hx-multi-year-view
        [activeDate]="activeDate()"
        [dateAdapter]="dateAdapter()"
        [maxDate]="maxDate()"
        [minDate]="minDate()"
        [allowedYears]="allowedYears()"
        [selected]="selected()"
        (activeDateChange)="onActiveDateChange($event)"
        (selectedChange)="onDateSelected($event)" />
    }
  }
</div>
